import React from "react";
import News from "../../../component/News";
import NoticeAndUpcomingEvents from "../../../component/NoticeAndUpcomingEvents";

const NewsNoticeForDepartmentAndFaculty = ({ config }) => {
  return (
    <div className="facultyContent mt-5">
      <div className="DeptRightSideNewsAndEvents">
        <News newsConfig={config} />

        <NoticeAndUpcomingEvents noticeConfig={config} />
      </div>
    </div>
  );
};

export default NewsNoticeForDepartmentAndFaculty;
